var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPerfromanceReports(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 145,
    viewBox: "0 0 178 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29236 32.8035C7.78469 30.8469 12.7495 29.0106 18.5745 29.14C28.6857 29.3647 38.5122 31.8457 48.5439 32.8035C60.0497 33.9021 70.0327 32.0797 79.6835 25.4766",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75031 35.0938C3.01517 36.1532 5.50158 38.0539 6.41379 38.4774C8.71806 39.5472 8.88738 41.0628 10.7896 42.5734C12.5078 43.9378 12.8932 46.0761 14.504 47.4326C17.0053 49.5389 21.3127 48.1114 22.874 51.8847C24.0543 54.737 23.24 58.1708 24.4768 61.0943C25.137 62.6547 26.057 64.1197 27.1227 65.4193C28.6434 67.2739 28.3246 69.6699 28.8526 71.8812C30.5313 78.9107 29.2715 87.0626 29.7685 94.2692C30.4531 104.196 32.5161 113.769 32.5161 123.755C32.5161 129.903 32.5161 136.052 32.5161 142.2C32.5161 143.814 32.7266 138.934 33.2793 137.417C34.2172 134.843 36.1378 132.588 37.8587 130.497C40.9282 126.767 44.2417 123.56 48.1368 120.728C54.2492 116.282 61.2919 117.368 68.3877 116.81C80.3726 115.867 92.4932 117.015 104.412 115.69",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7676 25.9297C78.7676 29.7964 78.7404 33.6641 78.7676 37.5307C78.7947 41.3836 79.7548 43.652 81.4389 47.0202C82.1015 48.3455 82.3371 49.7384 82.8381 51.1161C83.6468 53.3401 85.0605 55.26 85.7893 57.5272C86.7979 60.6652 86.7427 64.002 87.4684 67.1948C88.8985 73.4873 92.4636 78.6874 94.5664 84.7744C95.8126 88.382 96.7482 94.0606 100.036 96.4518C101.251 97.3353 101.81 99.5836 102.224 100.929C103.129 103.871 105.049 105.808 106.244 108.511C107.906 112.273 110 115.08 103.954 115.685",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9368 50.2025C37.7629 48.2632 48.1177 46.5391 58.1605 46.5391",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5534 70.8125L53.1232 67.6025",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5908 99.8594L85.2796 88.8086",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.203 60.4219L58.1605 55.61",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2628 101.953C84.0426 103.054 82.6273 104.084 83.6014 105.337C84.3234 106.265 85.5681 106.846 86.756 106.507C88.5867 105.984 85.1787 101.162 85.1787 104.243",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7422 70.4973C90.1532 68.5786 93.7341 63.7023 95.3452 61.5346C96.0313 60.6114 96.5933 59.5687 97.4471 58.7982C97.773 58.504 100.223 60.1247 100.263 60.1465C103.107 61.6923 105.974 63.1827 108.928 64.5089C110.11 65.0395 111.342 65.6444 112.616 65.9366C113.698 66.1846 114.794 66.4483 115.888 66.6306C117.063 66.8264 117.281 65.4799 117.673 64.5684C120.206 58.666 121.993 52.4916 123.364 46.2266",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M118.724 48.1933C120.429 47.0044 122.116 45.759 123.879 44.6538C124.382 44.3385 124.444 44.5149 124.811 44.9215C125.176 45.3256 127.29 51.76 127.815 51.9352",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2022 2.0625V28.1349",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7769 43.2891V86.9451",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7769 88.7656H25.3289",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.089 88.1562H173.274",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.849 82.0938C171.371 82.6887 176.849 87.0153 175.565 88.4603C173.704 90.5544 170.083 90.7954 168.424 93.0078",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98175 5.87599C9.44291 4.79513 10.9465 3.7513 12.2613 2.48912C12.5316 2.22961 12.7958 1.80336 13.1802 1.67522C14.2686 1.31243 15.4975 2.74498 16.1864 3.35553C16.6781 3.79134 17.043 4.35252 17.6698 4.57638C18.178 4.7579 18.2785 4.71849 18.6149 5.16711",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPerfromanceReports);
export default __webpack_public_path__ + "static/media/noPerfromanceReports.1a070f4ec997874ad696c0b0db1ba88c.svg";
export { ForwardRef as ReactComponent };